/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Api
 * MarketMind API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Alert,
  AlertInput,
  AlertList,
  AlertPatch,
  AlertSettings,
  AlertSettingsPatch,
  Analysis,
  AnalysisInput,
  AnalysisList,
  AttributeReferralInput,
  AttributeReferralResult,
  ChatMessage,
  ChatMessageInput,
  ChatMessageList,
  DashboardData,
  GetMarketHistoryParams,
  GetMarketParams,
  HealthStatus,
  Integration,
  IntegrationInput,
  IntegrationList,
  KalshiOrder,
  KalshiOrderInput,
  KalshiOrderList,
  ListAnalysesParams,
  ListKalshiOrdersParams,
  ListMarketsParams,
  ListPicksParams,
  ListPositionsParams,
  Market,
  MarketList,
  PickList,
  PortfolioSummary,
  Position,
  PositionInput,
  PositionList,
  PositionPatch,
  PriceHistory,
  PublicAnalysis,
  ReferralClickInput,
  ReferralClickMatchInput,
  ReferralClickMatchResult,
  ReferralStatus,
  RemoveFromWatchlistByMarketParams,
  ShareResponse,
  Subscription,
  User,
  UserPatch,
  WatchlistInput,
  WatchlistItem,
  WatchlistList
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListMarketsUrl = (params?: ListMarketsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/markets?${stringifiedParams}` : `/api/markets`
}

/**
 * @summary Browse and search live prediction markets
 */
export const listMarkets = async (params?: ListMarketsParams, options?: Parameters<typeof customFetch>[1]): Promise<MarketList> => {

  return customFetch<MarketList>(getListMarketsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMarketsQueryKey = (params?: ListMarketsParams,) => {
    return [
    `/api/markets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMarketsQueryOptions = <TData = Awaited<ReturnType<typeof listMarkets>>, TError = ErrorType<unknown>>(params?: ListMarketsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMarkets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMarketsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMarkets>>> = ({ signal }) => listMarkets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMarkets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMarketsQueryResult = NonNullable<Awaited<ReturnType<typeof listMarkets>>>
export type ListMarketsQueryError = ErrorType<unknown>


/**
 * @summary Browse and search live prediction markets
 */

export function useListMarkets<TData = Awaited<ReturnType<typeof listMarkets>>, TError = ErrorType<unknown>>(
 params?: ListMarketsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMarkets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMarketsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMarketUrl = (marketId: string,
    params?: GetMarketParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/markets/${marketId}?${stringifiedParams}` : `/api/markets/${marketId}`
}

/**
 * @summary Get a single market by ID
 */
export const getMarket = async (marketId: string,
    params?: GetMarketParams, options?: Parameters<typeof customFetch>[1]): Promise<Market> => {

  return customFetch<Market>(getGetMarketUrl(marketId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMarketQueryKey = (marketId: string,
    params?: GetMarketParams,) => {
    return [
    `/api/markets/${marketId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMarketQueryOptions = <TData = Awaited<ReturnType<typeof getMarket>>, TError = ErrorType<void>>(marketId: string,
    params?: GetMarketParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarket>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketQueryKey(marketId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarket>>> = ({ signal }) => getMarket(marketId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: marketId !== null && marketId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarket>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMarketQueryResult = NonNullable<Awaited<ReturnType<typeof getMarket>>>
export type GetMarketQueryError = ErrorType<void>


/**
 * @summary Get a single market by ID
 */

export function useGetMarket<TData = Awaited<ReturnType<typeof getMarket>>, TError = ErrorType<void>>(
 marketId: string,
    params?: GetMarketParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarket>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMarketQueryOptions(marketId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMarketHistoryUrl = (marketId: string,
    params?: GetMarketHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/markets/${marketId}/history?${stringifiedParams}` : `/api/markets/${marketId}/history`
}

/**
 * @summary Get YES price history for a market
 */
export const getMarketHistory = async (marketId: string,
    params?: GetMarketHistoryParams, options?: Parameters<typeof customFetch>[1]): Promise<PriceHistory> => {

  return customFetch<PriceHistory>(getGetMarketHistoryUrl(marketId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMarketHistoryQueryKey = (marketId: string,
    params?: GetMarketHistoryParams,) => {
    return [
    `/api/markets/${marketId}/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMarketHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getMarketHistory>>, TError = ErrorType<void>>(marketId: string,
    params?: GetMarketHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketHistoryQueryKey(marketId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketHistory>>> = ({ signal }) => getMarketHistory(marketId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: marketId !== null && marketId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMarketHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketHistory>>>
export type GetMarketHistoryQueryError = ErrorType<void>


/**
 * @summary Get YES price history for a market
 */

export function useGetMarketHistory<TData = Awaited<ReturnType<typeof getMarketHistory>>, TError = ErrorType<void>>(
 marketId: string,
    params?: GetMarketHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMarketHistoryQueryOptions(marketId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAnalysesUrl = (params?: ListAnalysesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/analyses?${stringifiedParams}` : `/api/analyses`
}

/**
 * @summary List the current user's analyses
 */
export const listAnalyses = async (params?: ListAnalysesParams, options?: Parameters<typeof customFetch>[1]): Promise<AnalysisList> => {

  return customFetch<AnalysisList>(getListAnalysesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAnalysesQueryKey = (params?: ListAnalysesParams,) => {
    return [
    `/api/analyses`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAnalysesQueryOptions = <TData = Awaited<ReturnType<typeof listAnalyses>>, TError = ErrorType<unknown>>(params?: ListAnalysesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalyses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAnalysesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAnalyses>>> = ({ signal }) => listAnalyses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAnalyses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAnalysesQueryResult = NonNullable<Awaited<ReturnType<typeof listAnalyses>>>
export type ListAnalysesQueryError = ErrorType<unknown>


/**
 * @summary List the current user's analyses
 */

export function useListAnalyses<TData = Awaited<ReturnType<typeof listAnalyses>>, TError = ErrorType<unknown>>(
 params?: ListAnalysesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalyses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAnalysesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAnalysisUrl = () => {




  return `/api/analyses`
}

/**
 * @summary Create an AI analysis for a market (runs asynchronously — poll GET /analyses/{id})
 */
export const createAnalysis = async (analysisInput: AnalysisInput, options?: Parameters<typeof customFetch>[1]): Promise<Analysis> => {

  return customFetch<Analysis>(getCreateAnalysisUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(analysisInput)
  }
);}





export const getCreateAnalysisMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalysis>>, TError,{data: BodyType<AnalysisInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAnalysis>>, TError,{data: BodyType<AnalysisInput>}, TContext> => {

const mutationKey = ['createAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnalysis>>, {data: BodyType<AnalysisInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAnalysis(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof createAnalysis>>>
    export type CreateAnalysisMutationBody = BodyType<AnalysisInput>
    export type CreateAnalysisMutationError = ErrorType<void>

    /**
 * @summary Create an AI analysis for a market (runs asynchronously — poll GET /analyses/{id})
 */
export const useCreateAnalysis = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalysis>>, TError,{data: BodyType<AnalysisInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAnalysis>>,
        TError,
        {data: BodyType<AnalysisInput>},
        TContext
      > => {
      return useMutation(getCreateAnalysisMutationOptions(options));
    }

export const getGetAnalysisUrl = (id: number,) => {




  return `/api/analyses/${id}`
}

/**
 * @summary Get a single analysis (poll until status is complete or failed)
 */
export const getAnalysis = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Analysis> => {

  return customFetch<Analysis>(getGetAnalysisUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAnalysisQueryKey = (id: number,) => {
    return [
    `/api/analyses/${id}`
    ] as const;
    }


export const getGetAnalysisQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysis>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysis>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysis>>> = ({ signal }) => getAnalysis(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysis>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAnalysisQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysis>>>
export type GetAnalysisQueryError = ErrorType<void>


/**
 * @summary Get a single analysis (poll until status is complete or failed)
 */

export function useGetAnalysis<TData = Awaited<ReturnType<typeof getAnalysis>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysis>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAnalysisQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteAnalysisUrl = (id: number,) => {




  return `/api/analyses/${id}`
}

/**
 * @summary Delete an analysis
 */
export const deleteAnalysis = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteAnalysisUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAnalysisMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnalysis>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAnalysis>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAnalysis>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAnalysis(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAnalysis>>>

    export type DeleteAnalysisMutationError = ErrorType<unknown>

    /**
 * @summary Delete an analysis
 */
export const useDeleteAnalysis = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnalysis>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAnalysis>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAnalysisMutationOptions(options));
    }

export const getListPositionsUrl = (params?: ListPositionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/positions?${stringifiedParams}` : `/api/positions`
}

/**
 * @summary List user's tracked positions
 */
export const listPositions = async (params?: ListPositionsParams, options?: Parameters<typeof customFetch>[1]): Promise<PositionList> => {

  return customFetch<PositionList>(getListPositionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPositionsQueryKey = (params?: ListPositionsParams,) => {
    return [
    `/api/positions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPositionsQueryOptions = <TData = Awaited<ReturnType<typeof listPositions>>, TError = ErrorType<unknown>>(params?: ListPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPositions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPositionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPositions>>> = ({ signal }) => listPositions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPositions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPositionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPositions>>>
export type ListPositionsQueryError = ErrorType<unknown>


/**
 * @summary List user's tracked positions
 */

export function useListPositions<TData = Awaited<ReturnType<typeof listPositions>>, TError = ErrorType<unknown>>(
 params?: ListPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPositions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPositionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePositionUrl = () => {




  return `/api/positions`
}

/**
 * @summary Add a new tracked position
 */
export const createPosition = async (positionInput: PositionInput, options?: Parameters<typeof customFetch>[1]): Promise<Position> => {

  return customFetch<Position>(getCreatePositionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(positionInput)
  }
);}





export const getCreatePositionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPosition>>, TError,{data: BodyType<PositionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPosition>>, TError,{data: BodyType<PositionInput>}, TContext> => {

const mutationKey = ['createPosition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPosition>>, {data: BodyType<PositionInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPosition(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePositionMutationResult = NonNullable<Awaited<ReturnType<typeof createPosition>>>
    export type CreatePositionMutationBody = BodyType<PositionInput>
    export type CreatePositionMutationError = ErrorType<unknown>

    /**
 * @summary Add a new tracked position
 */
export const useCreatePosition = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPosition>>, TError,{data: BodyType<PositionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPosition>>,
        TError,
        {data: BodyType<PositionInput>},
        TContext
      > => {
      return useMutation(getCreatePositionMutationOptions(options));
    }

export const getUpdatePositionUrl = (id: number,) => {




  return `/api/positions/${id}`
}

/**
 * @summary Update a position (price, status, outcome, notes)
 */
export const updatePosition = async (id: number,
    positionPatch: PositionPatch, options?: Parameters<typeof customFetch>[1]): Promise<Position> => {

  return customFetch<Position>(getUpdatePositionUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(positionPatch)
  }
);}





export const getUpdatePositionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePosition>>, TError,{id: number;data: BodyType<PositionPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePosition>>, TError,{id: number;data: BodyType<PositionPatch>}, TContext> => {

const mutationKey = ['updatePosition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePosition>>, {id: number;data: BodyType<PositionPatch>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePosition(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePositionMutationResult = NonNullable<Awaited<ReturnType<typeof updatePosition>>>
    export type UpdatePositionMutationBody = BodyType<PositionPatch>
    export type UpdatePositionMutationError = ErrorType<void>

    /**
 * @summary Update a position (price, status, outcome, notes)
 */
export const useUpdatePosition = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePosition>>, TError,{id: number;data: BodyType<PositionPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePosition>>,
        TError,
        {id: number;data: BodyType<PositionPatch>},
        TContext
      > => {
      return useMutation(getUpdatePositionMutationOptions(options));
    }

export const getDeletePositionUrl = (id: number,) => {




  return `/api/positions/${id}`
}

/**
 * @summary Delete a position
 */
export const deletePosition = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeletePositionUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePositionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePosition>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePosition>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePosition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePosition>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePosition(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePositionMutationResult = NonNullable<Awaited<ReturnType<typeof deletePosition>>>

    export type DeletePositionMutationError = ErrorType<unknown>

    /**
 * @summary Delete a position
 */
export const useDeletePosition = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePosition>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePosition>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePositionMutationOptions(options));
    }

export const getGetPortfolioSummaryUrl = () => {




  return `/api/portfolio/summary`
}

/**
 * @summary Get portfolio performance summary (P&L, win rate, AI accuracy)
 */
export const getPortfolioSummary = async ( options?: Parameters<typeof customFetch>[1]): Promise<PortfolioSummary> => {

  return customFetch<PortfolioSummary>(getGetPortfolioSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPortfolioSummaryQueryKey = () => {
    return [
    `/api/portfolio/summary`
    ] as const;
    }


export const getGetPortfolioSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPortfolioSummary>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortfolioSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPortfolioSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPortfolioSummary>>> = ({ signal }) => getPortfolioSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPortfolioSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPortfolioSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPortfolioSummary>>>
export type GetPortfolioSummaryQueryError = ErrorType<unknown>


/**
 * @summary Get portfolio performance summary (P&L, win rate, AI accuracy)
 */

export function useGetPortfolioSummary<TData = Awaited<ReturnType<typeof getPortfolioSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortfolioSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPortfolioSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAlertsUrl = () => {




  return `/api/alerts`
}

/**
 * @summary List user's price alerts
 */
export const listAlerts = async ( options?: Parameters<typeof customFetch>[1]): Promise<AlertList> => {

  return customFetch<AlertList>(getListAlertsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAlertsQueryKey = () => {
    return [
    `/api/alerts`
    ] as const;
    }


export const getListAlertsQueryOptions = <TData = Awaited<ReturnType<typeof listAlerts>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAlerts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAlertsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAlerts>>> = ({ signal }) => listAlerts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAlerts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAlertsQueryResult = NonNullable<Awaited<ReturnType<typeof listAlerts>>>
export type ListAlertsQueryError = ErrorType<unknown>


/**
 * @summary List user's price alerts
 */

export function useListAlerts<TData = Awaited<ReturnType<typeof listAlerts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAlerts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAlertsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAlertUrl = () => {




  return `/api/alerts`
}

/**
 * @summary Create a price alert
 */
export const createAlert = async (alertInput: AlertInput, options?: Parameters<typeof customFetch>[1]): Promise<Alert> => {

  return customFetch<Alert>(getCreateAlertUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(alertInput)
  }
);}





export const getCreateAlertMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAlert>>, TError,{data: BodyType<AlertInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAlert>>, TError,{data: BodyType<AlertInput>}, TContext> => {

const mutationKey = ['createAlert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAlert>>, {data: BodyType<AlertInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAlert(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAlertMutationResult = NonNullable<Awaited<ReturnType<typeof createAlert>>>
    export type CreateAlertMutationBody = BodyType<AlertInput>
    export type CreateAlertMutationError = ErrorType<unknown>

    /**
 * @summary Create a price alert
 */
export const useCreateAlert = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAlert>>, TError,{data: BodyType<AlertInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAlert>>,
        TError,
        {data: BodyType<AlertInput>},
        TContext
      > => {
      return useMutation(getCreateAlertMutationOptions(options));
    }

export const getUpdateAlertUrl = (id: number,) => {




  return `/api/alerts/${id}`
}

/**
 * @summary Update an alert
 */
export const updateAlert = async (id: number,
    alertPatch: AlertPatch, options?: Parameters<typeof customFetch>[1]): Promise<Alert> => {

  return customFetch<Alert>(getUpdateAlertUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(alertPatch)
  }
);}





export const getUpdateAlertMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAlert>>, TError,{id: number;data: BodyType<AlertPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAlert>>, TError,{id: number;data: BodyType<AlertPatch>}, TContext> => {

const mutationKey = ['updateAlert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAlert>>, {id: number;data: BodyType<AlertPatch>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAlert(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAlertMutationResult = NonNullable<Awaited<ReturnType<typeof updateAlert>>>
    export type UpdateAlertMutationBody = BodyType<AlertPatch>
    export type UpdateAlertMutationError = ErrorType<void>

    /**
 * @summary Update an alert
 */
export const useUpdateAlert = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAlert>>, TError,{id: number;data: BodyType<AlertPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAlert>>,
        TError,
        {id: number;data: BodyType<AlertPatch>},
        TContext
      > => {
      return useMutation(getUpdateAlertMutationOptions(options));
    }

export const getDeleteAlertUrl = (id: number,) => {




  return `/api/alerts/${id}`
}

/**
 * @summary Delete an alert
 */
export const deleteAlert = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteAlertUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAlertMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAlert>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAlert>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAlert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAlert>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAlert(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAlertMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAlert>>>

    export type DeleteAlertMutationError = ErrorType<unknown>

    /**
 * @summary Delete an alert
 */
export const useDeleteAlert = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAlert>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAlert>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAlertMutationOptions(options));
    }

export const getGetAlertSettingsUrl = () => {




  return `/api/alert-settings`
}

/**
 * @summary Get user's alert delivery preferences
 */
export const getAlertSettings = async ( options?: Parameters<typeof customFetch>[1]): Promise<AlertSettings> => {

  return customFetch<AlertSettings>(getGetAlertSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAlertSettingsQueryKey = () => {
    return [
    `/api/alert-settings`
    ] as const;
    }


export const getGetAlertSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAlertSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlertSettings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlertSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlertSettings>>> = ({ signal }) => getAlertSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAlertSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAlertSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAlertSettings>>>
export type GetAlertSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get user's alert delivery preferences
 */

export function useGetAlertSettings<TData = Awaited<ReturnType<typeof getAlertSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlertSettings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAlertSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAlertSettingsUrl = () => {




  return `/api/alert-settings`
}

/**
 * @summary Update alert delivery preferences
 */
export const updateAlertSettings = async (alertSettingsPatch: AlertSettingsPatch, options?: Parameters<typeof customFetch>[1]): Promise<AlertSettings> => {

  return customFetch<AlertSettings>(getUpdateAlertSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(alertSettingsPatch)
  }
);}





export const getUpdateAlertSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAlertSettings>>, TError,{data: BodyType<AlertSettingsPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAlertSettings>>, TError,{data: BodyType<AlertSettingsPatch>}, TContext> => {

const mutationKey = ['updateAlertSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAlertSettings>>, {data: BodyType<AlertSettingsPatch>}> = (props) => {
          const {data} = props ?? {};

          return  updateAlertSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAlertSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAlertSettings>>>
    export type UpdateAlertSettingsMutationBody = BodyType<AlertSettingsPatch>
    export type UpdateAlertSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update alert delivery preferences
 */
export const useUpdateAlertSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAlertSettings>>, TError,{data: BodyType<AlertSettingsPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAlertSettings>>,
        TError,
        {data: BodyType<AlertSettingsPatch>},
        TContext
      > => {
      return useMutation(getUpdateAlertSettingsMutationOptions(options));
    }

export const getListIntegrationsUrl = () => {




  return `/api/integrations`
}

/**
 * @summary List connected trading accounts
 */
export const listIntegrations = async ( options?: Parameters<typeof customFetch>[1]): Promise<IntegrationList> => {

  return customFetch<IntegrationList>(getListIntegrationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListIntegrationsQueryKey = () => {
    return [
    `/api/integrations`
    ] as const;
    }


export const getListIntegrationsQueryOptions = <TData = Awaited<ReturnType<typeof listIntegrations>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIntegrationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIntegrations>>> = ({ signal }) => listIntegrations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof listIntegrations>>>
export type ListIntegrationsQueryError = ErrorType<unknown>


/**
 * @summary List connected trading accounts
 */

export function useListIntegrations<TData = Awaited<ReturnType<typeof listIntegrations>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListIntegrationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getConnectIntegrationUrl = () => {




  return `/api/integrations`
}

/**
 * @summary Connect a trading account (Kalshi API key)
 */
export const connectIntegration = async (integrationInput: IntegrationInput, options?: Parameters<typeof customFetch>[1]): Promise<Integration> => {

  return customFetch<Integration>(getConnectIntegrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(integrationInput)
  }
);}





export const getConnectIntegrationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectIntegration>>, TError,{data: BodyType<IntegrationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof connectIntegration>>, TError,{data: BodyType<IntegrationInput>}, TContext> => {

const mutationKey = ['connectIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectIntegration>>, {data: BodyType<IntegrationInput>}> = (props) => {
          const {data} = props ?? {};

          return  connectIntegration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof connectIntegration>>>
    export type ConnectIntegrationMutationBody = BodyType<IntegrationInput>
    export type ConnectIntegrationMutationError = ErrorType<void>

    /**
 * @summary Connect a trading account (Kalshi API key)
 */
export const useConnectIntegration = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectIntegration>>, TError,{data: BodyType<IntegrationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof connectIntegration>>,
        TError,
        {data: BodyType<IntegrationInput>},
        TContext
      > => {
      return useMutation(getConnectIntegrationMutationOptions(options));
    }

export const getDeleteIntegrationUrl = (id: number,) => {




  return `/api/integrations/${id}`
}

/**
 * @summary Disconnect a trading account
 */
export const deleteIntegration = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteIntegrationUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegration>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntegration>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntegration>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteIntegration(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegration>>>

    export type DeleteIntegrationMutationError = ErrorType<unknown>

    /**
 * @summary Disconnect a trading account
 */
export const useDeleteIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegration>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteIntegration>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteIntegrationMutationOptions(options));
    }

export const getListKalshiOrdersUrl = (id: number,
    params?: ListKalshiOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/${id}/orders?${stringifiedParams}` : `/api/integrations/${id}/orders`
}

/**
 * @summary List orders from a connected Kalshi account
 */
export const listKalshiOrders = async (id: number,
    params?: ListKalshiOrdersParams, options?: Parameters<typeof customFetch>[1]): Promise<KalshiOrderList> => {

  return customFetch<KalshiOrderList>(getListKalshiOrdersUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListKalshiOrdersQueryKey = (id: number,
    params?: ListKalshiOrdersParams,) => {
    return [
    `/api/integrations/${id}/orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListKalshiOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listKalshiOrders>>, TError = ErrorType<unknown>>(id: number,
    params?: ListKalshiOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listKalshiOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListKalshiOrdersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listKalshiOrders>>> = ({ signal }) => listKalshiOrders(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listKalshiOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListKalshiOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listKalshiOrders>>>
export type ListKalshiOrdersQueryError = ErrorType<unknown>


/**
 * @summary List orders from a connected Kalshi account
 */

export function useListKalshiOrders<TData = Awaited<ReturnType<typeof listKalshiOrders>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ListKalshiOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listKalshiOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListKalshiOrdersQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPlaceKalshiOrderUrl = (id: number,) => {




  return `/api/integrations/${id}/orders`
}

/**
 * @summary Place a trade on Kalshi
 */
export const placeKalshiOrder = async (id: number,
    kalshiOrderInput: KalshiOrderInput, options?: Parameters<typeof customFetch>[1]): Promise<KalshiOrder> => {

  return customFetch<KalshiOrder>(getPlaceKalshiOrderUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(kalshiOrderInput)
  }
);}





export const getPlaceKalshiOrderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof placeKalshiOrder>>, TError,{id: number;data: BodyType<KalshiOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof placeKalshiOrder>>, TError,{id: number;data: BodyType<KalshiOrderInput>}, TContext> => {

const mutationKey = ['placeKalshiOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof placeKalshiOrder>>, {id: number;data: BodyType<KalshiOrderInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  placeKalshiOrder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlaceKalshiOrderMutationResult = NonNullable<Awaited<ReturnType<typeof placeKalshiOrder>>>
    export type PlaceKalshiOrderMutationBody = BodyType<KalshiOrderInput>
    export type PlaceKalshiOrderMutationError = ErrorType<void>

    /**
 * @summary Place a trade on Kalshi
 */
export const usePlaceKalshiOrder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof placeKalshiOrder>>, TError,{id: number;data: BodyType<KalshiOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof placeKalshiOrder>>,
        TError,
        {id: number;data: BodyType<KalshiOrderInput>},
        TContext
      > => {
      return useMutation(getPlaceKalshiOrderMutationOptions(options));
    }

export const getListPicksUrl = (params?: ListPicksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/picks?${stringifiedParams}` : `/api/picks`
}

/**
 * @summary Public top picks feed (highest-confidence AI recommendations)
 */
export const listPicks = async (params?: ListPicksParams, options?: Parameters<typeof customFetch>[1]): Promise<PickList> => {

  return customFetch<PickList>(getListPicksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPicksQueryKey = (params?: ListPicksParams,) => {
    return [
    `/api/picks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPicksQueryOptions = <TData = Awaited<ReturnType<typeof listPicks>>, TError = ErrorType<unknown>>(params?: ListPicksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPicks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPicksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPicks>>> = ({ signal }) => listPicks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPicks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPicksQueryResult = NonNullable<Awaited<ReturnType<typeof listPicks>>>
export type ListPicksQueryError = ErrorType<unknown>


/**
 * @summary Public top picks feed (highest-confidence AI recommendations)
 */

export function useListPicks<TData = Awaited<ReturnType<typeof listPicks>>, TError = ErrorType<unknown>>(
 params?: ListPicksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPicks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPicksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetDashboardUrl = () => {




  return `/api/dashboard`
}

/**
 * @summary Dashboard summary for authenticated user
 */
export const getDashboard = async ( options?: Parameters<typeof customFetch>[1]): Promise<DashboardData> => {

  return customFetch<DashboardData>(getGetDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardQueryKey = () => {
    return [
    `/api/dashboard`
    ] as const;
    }


export const getGetDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getDashboard>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboard>>> = ({ signal }) => getDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboard>>>
export type GetDashboardQueryError = ErrorType<unknown>


/**
 * @summary Dashboard summary for authenticated user
 */

export function useGetDashboard<TData = Awaited<ReturnType<typeof getDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMeUrl = () => {




  return `/api/users/me`
}

/**
 * @summary Get current user profile
 */
export const getMe = async ( options?: Parameters<typeof customFetch>[1]): Promise<User> => {

  return customFetch<User>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/users/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<unknown>


/**
 * @summary Get current user profile
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateMeUrl = () => {




  return `/api/users/me`
}

/**
 * @summary Update current user profile
 */
export const updateMe = async (userPatch: UserPatch, options?: Parameters<typeof customFetch>[1]): Promise<User> => {

  return customFetch<User>(getUpdateMeUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userPatch)
  }
);}





export const getUpdateMeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,{data: BodyType<UserPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,{data: BodyType<UserPatch>}, TContext> => {

const mutationKey = ['updateMe'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMe>>, {data: BodyType<UserPatch>}> = (props) => {
          const {data} = props ?? {};

          return  updateMe(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMeMutationResult = NonNullable<Awaited<ReturnType<typeof updateMe>>>
    export type UpdateMeMutationBody = BodyType<UserPatch>
    export type UpdateMeMutationError = ErrorType<unknown>

    /**
 * @summary Update current user profile
 */
export const useUpdateMe = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,{data: BodyType<UserPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMe>>,
        TError,
        {data: BodyType<UserPatch>},
        TContext
      > => {
      return useMutation(getUpdateMeMutationOptions(options));
    }

export const getGetSubscriptionUrl = () => {




  return `/api/subscription`
}

/**
 * @summary Get user's subscription tier and usage
 */
export const getSubscription = async ( options?: Parameters<typeof customFetch>[1]): Promise<Subscription> => {

  return customFetch<Subscription>(getGetSubscriptionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSubscriptionQueryKey = () => {
    return [
    `/api/subscription`
    ] as const;
    }


export const getGetSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getSubscription>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscription>>> = ({ signal }) => getSubscription({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscription>>>
export type GetSubscriptionQueryError = ErrorType<unknown>


/**
 * @summary Get user's subscription tier and usage
 */

export function useGetSubscription<TData = Awaited<ReturnType<typeof getSubscription>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSubscriptionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMyReferralsUrl = () => {




  return `/api/referrals/me`
}

/**
 * @summary Get the current user's referral link/code and reward status
 */
export const getMyReferrals = async ( options?: Parameters<typeof customFetch>[1]): Promise<ReferralStatus> => {

  return customFetch<ReferralStatus>(getGetMyReferralsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyReferralsQueryKey = () => {
    return [
    `/api/referrals/me`
    ] as const;
    }


export const getGetMyReferralsQueryOptions = <TData = Awaited<ReturnType<typeof getMyReferrals>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReferrals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyReferralsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyReferrals>>> = ({ signal }) => getMyReferrals({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyReferrals>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyReferralsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyReferrals>>>
export type GetMyReferralsQueryError = ErrorType<unknown>


/**
 * @summary Get the current user's referral link/code and reward status
 */

export function useGetMyReferrals<TData = Awaited<ReturnType<typeof getMyReferrals>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReferrals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyReferralsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAttributeReferralUrl = () => {




  return `/api/referrals/attribute`
}

/**
 * @summary Record that the current user signed up via another user's referral code
 */
export const attributeReferral = async (attributeReferralInput: AttributeReferralInput, options?: Parameters<typeof customFetch>[1]): Promise<AttributeReferralResult> => {

  return customFetch<AttributeReferralResult>(getAttributeReferralUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(attributeReferralInput)
  }
);}





export const getAttributeReferralMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attributeReferral>>, TError,{data: BodyType<AttributeReferralInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof attributeReferral>>, TError,{data: BodyType<AttributeReferralInput>}, TContext> => {

const mutationKey = ['attributeReferral'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attributeReferral>>, {data: BodyType<AttributeReferralInput>}> = (props) => {
          const {data} = props ?? {};

          return  attributeReferral(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AttributeReferralMutationResult = NonNullable<Awaited<ReturnType<typeof attributeReferral>>>
    export type AttributeReferralMutationBody = BodyType<AttributeReferralInput>
    export type AttributeReferralMutationError = ErrorType<void>

    /**
 * @summary Record that the current user signed up via another user's referral code
 */
export const useAttributeReferral = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attributeReferral>>, TError,{data: BodyType<AttributeReferralInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof attributeReferral>>,
        TError,
        {data: BodyType<AttributeReferralInput>},
        TContext
      > => {
      return useMutation(getAttributeReferralMutationOptions(options));
    }

export const getTrackReferralClickUrl = () => {




  return `/api/referrals/click`
}

/**
 * @summary Record that a referral link was tapped, fingerprinted by IP + platform, so the code can still be attributed after a fresh app install (deferred deep linking) even though the tapper doesn't have the app yet

 */
export const trackReferralClick = async (referralClickInput: ReferralClickInput, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getTrackReferralClickUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(referralClickInput)
  }
);}





export const getTrackReferralClickMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trackReferralClick>>, TError,{data: BodyType<ReferralClickInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof trackReferralClick>>, TError,{data: BodyType<ReferralClickInput>}, TContext> => {

const mutationKey = ['trackReferralClick'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof trackReferralClick>>, {data: BodyType<ReferralClickInput>}> = (props) => {
          const {data} = props ?? {};

          return  trackReferralClick(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TrackReferralClickMutationResult = NonNullable<Awaited<ReturnType<typeof trackReferralClick>>>
    export type TrackReferralClickMutationBody = BodyType<ReferralClickInput>
    export type TrackReferralClickMutationError = ErrorType<void>

    /**
 * @summary Record that a referral link was tapped, fingerprinted by IP + platform, so the code can still be attributed after a fresh app install (deferred deep linking) even though the tapper doesn't have the app yet

 */
export const useTrackReferralClick = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trackReferralClick>>, TError,{data: BodyType<ReferralClickInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof trackReferralClick>>,
        TError,
        {data: BodyType<ReferralClickInput>},
        TContext
      > => {
      return useMutation(getTrackReferralClickMutationOptions(options));
    }

export const getMatchReferralClickUrl = () => {




  return `/api/referrals/match-click`
}

/**
 * @summary Look up (and consume) the most recent pending referral click matching this device's IP + platform fingerprint, called on app launch before the user signs in

 */
export const matchReferralClick = async (referralClickMatchInput: ReferralClickMatchInput, options?: Parameters<typeof customFetch>[1]): Promise<ReferralClickMatchResult> => {

  return customFetch<ReferralClickMatchResult>(getMatchReferralClickUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(referralClickMatchInput)
  }
);}





export const getMatchReferralClickMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchReferralClick>>, TError,{data: BodyType<ReferralClickMatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof matchReferralClick>>, TError,{data: BodyType<ReferralClickMatchInput>}, TContext> => {

const mutationKey = ['matchReferralClick'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchReferralClick>>, {data: BodyType<ReferralClickMatchInput>}> = (props) => {
          const {data} = props ?? {};

          return  matchReferralClick(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MatchReferralClickMutationResult = NonNullable<Awaited<ReturnType<typeof matchReferralClick>>>
    export type MatchReferralClickMutationBody = BodyType<ReferralClickMatchInput>
    export type MatchReferralClickMutationError = ErrorType<unknown>

    /**
 * @summary Look up (and consume) the most recent pending referral click matching this device's IP + platform fingerprint, called on app launch before the user signs in

 */
export const useMatchReferralClick = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchReferralClick>>, TError,{data: BodyType<ReferralClickMatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof matchReferralClick>>,
        TError,
        {data: BodyType<ReferralClickMatchInput>},
        TContext
      > => {
      return useMutation(getMatchReferralClickMutationOptions(options));
    }

export const getListWatchlistUrl = () => {




  return `/api/watchlist`
}

/**
 * @summary List user's watchlisted markets
 */
export const listWatchlist = async ( options?: Parameters<typeof customFetch>[1]): Promise<WatchlistList> => {

  return customFetch<WatchlistList>(getListWatchlistUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWatchlistQueryKey = () => {
    return [
    `/api/watchlist`
    ] as const;
    }


export const getListWatchlistQueryOptions = <TData = Awaited<ReturnType<typeof listWatchlist>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWatchlist>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWatchlistQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWatchlist>>> = ({ signal }) => listWatchlist({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWatchlist>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWatchlistQueryResult = NonNullable<Awaited<ReturnType<typeof listWatchlist>>>
export type ListWatchlistQueryError = ErrorType<unknown>


/**
 * @summary List user's watchlisted markets
 */

export function useListWatchlist<TData = Awaited<ReturnType<typeof listWatchlist>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWatchlist>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWatchlistQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddToWatchlistUrl = () => {




  return `/api/watchlist`
}

/**
 * @summary Add a market to the watchlist
 */
export const addToWatchlist = async (watchlistInput: WatchlistInput, options?: Parameters<typeof customFetch>[1]): Promise<WatchlistItem> => {

  return customFetch<WatchlistItem>(getAddToWatchlistUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(watchlistInput)
  }
);}





export const getAddToWatchlistMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addToWatchlist>>, TError,{data: BodyType<WatchlistInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addToWatchlist>>, TError,{data: BodyType<WatchlistInput>}, TContext> => {

const mutationKey = ['addToWatchlist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addToWatchlist>>, {data: BodyType<WatchlistInput>}> = (props) => {
          const {data} = props ?? {};

          return  addToWatchlist(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddToWatchlistMutationResult = NonNullable<Awaited<ReturnType<typeof addToWatchlist>>>
    export type AddToWatchlistMutationBody = BodyType<WatchlistInput>
    export type AddToWatchlistMutationError = ErrorType<unknown>

    /**
 * @summary Add a market to the watchlist
 */
export const useAddToWatchlist = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addToWatchlist>>, TError,{data: BodyType<WatchlistInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addToWatchlist>>,
        TError,
        {data: BodyType<WatchlistInput>},
        TContext
      > => {
      return useMutation(getAddToWatchlistMutationOptions(options));
    }

export const getRemoveFromWatchlistUrl = (id: number,) => {




  return `/api/watchlist/${id}`
}

/**
 * @summary Remove a market from the watchlist
 */
export const removeFromWatchlist = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRemoveFromWatchlistUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveFromWatchlistMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFromWatchlist>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeFromWatchlist>>, TError,{id: number}, TContext> => {

const mutationKey = ['removeFromWatchlist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeFromWatchlist>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  removeFromWatchlist(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveFromWatchlistMutationResult = NonNullable<Awaited<ReturnType<typeof removeFromWatchlist>>>

    export type RemoveFromWatchlistMutationError = ErrorType<unknown>

    /**
 * @summary Remove a market from the watchlist
 */
export const useRemoveFromWatchlist = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFromWatchlist>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeFromWatchlist>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRemoveFromWatchlistMutationOptions(options));
    }

export const getRemoveFromWatchlistByMarketUrl = (marketId: string,
    params: RemoveFromWatchlistByMarketParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/watchlist/market/${marketId}?${stringifiedParams}` : `/api/watchlist/market/${marketId}`
}

/**
 * @summary Remove a market from the watchlist by marketId + platform
 */
export const removeFromWatchlistByMarket = async (marketId: string,
    params: RemoveFromWatchlistByMarketParams, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRemoveFromWatchlistByMarketUrl(marketId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveFromWatchlistByMarketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFromWatchlistByMarket>>, TError,{marketId: string;params: RemoveFromWatchlistByMarketParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeFromWatchlistByMarket>>, TError,{marketId: string;params: RemoveFromWatchlistByMarketParams}, TContext> => {

const mutationKey = ['removeFromWatchlistByMarket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeFromWatchlistByMarket>>, {marketId: string;params: RemoveFromWatchlistByMarketParams}> = (props) => {
          const {marketId,params} = props ?? {};

          return  removeFromWatchlistByMarket(marketId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveFromWatchlistByMarketMutationResult = NonNullable<Awaited<ReturnType<typeof removeFromWatchlistByMarket>>>

    export type RemoveFromWatchlistByMarketMutationError = ErrorType<unknown>

    /**
 * @summary Remove a market from the watchlist by marketId + platform
 */
export const useRemoveFromWatchlistByMarket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFromWatchlistByMarket>>, TError,{marketId: string;params: RemoveFromWatchlistByMarketParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeFromWatchlistByMarket>>,
        TError,
        {marketId: string;params: RemoveFromWatchlistByMarketParams},
        TContext
      > => {
      return useMutation(getRemoveFromWatchlistByMarketMutationOptions(options));
    }

export const getGetAnalysisChatUrl = (id: number,) => {




  return `/api/analyses/${id}/chat`
}

/**
 * @summary Get chat history for an analysis
 */
export const getAnalysisChat = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ChatMessageList> => {

  return customFetch<ChatMessageList>(getGetAnalysisChatUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAnalysisChatQueryKey = (id: number,) => {
    return [
    `/api/analyses/${id}/chat`
    ] as const;
    }


export const getGetAnalysisChatQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisChat>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisChat>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisChatQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisChat>>> = ({ signal }) => getAnalysisChat(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisChat>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAnalysisChatQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisChat>>>
export type GetAnalysisChatQueryError = ErrorType<void>


/**
 * @summary Get chat history for an analysis
 */

export function useGetAnalysisChat<TData = Awaited<ReturnType<typeof getAnalysisChat>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisChat>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAnalysisChatQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendAnalysisChatMessageUrl = (id: number,) => {




  return `/api/analyses/${id}/chat`
}

/**
 * @summary Send a follow-up question about an analysis
 */
export const sendAnalysisChatMessage = async (id: number,
    chatMessageInput: ChatMessageInput, options?: Parameters<typeof customFetch>[1]): Promise<ChatMessage> => {

  return customFetch<ChatMessage>(getSendAnalysisChatMessageUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(chatMessageInput)
  }
);}





export const getSendAnalysisChatMessageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAnalysisChatMessage>>, TError,{id: number;data: BodyType<ChatMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendAnalysisChatMessage>>, TError,{id: number;data: BodyType<ChatMessageInput>}, TContext> => {

const mutationKey = ['sendAnalysisChatMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendAnalysisChatMessage>>, {id: number;data: BodyType<ChatMessageInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendAnalysisChatMessage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendAnalysisChatMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendAnalysisChatMessage>>>
    export type SendAnalysisChatMessageMutationBody = BodyType<ChatMessageInput>
    export type SendAnalysisChatMessageMutationError = ErrorType<void>

    /**
 * @summary Send a follow-up question about an analysis
 */
export const useSendAnalysisChatMessage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAnalysisChatMessage>>, TError,{id: number;data: BodyType<ChatMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendAnalysisChatMessage>>,
        TError,
        {id: number;data: BodyType<ChatMessageInput>},
        TContext
      > => {
      return useMutation(getSendAnalysisChatMessageMutationOptions(options));
    }

export const getShareAnalysisUrl = (id: number,) => {




  return `/api/analyses/${id}/share`
}

/**
 * @summary Generate a public share link for an analysis
 */
export const shareAnalysis = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ShareResponse> => {

  return customFetch<ShareResponse>(getShareAnalysisUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getShareAnalysisMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareAnalysis>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof shareAnalysis>>, TError,{id: number}, TContext> => {

const mutationKey = ['shareAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shareAnalysis>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  shareAnalysis(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ShareAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof shareAnalysis>>>

    export type ShareAnalysisMutationError = ErrorType<void>

    /**
 * @summary Generate a public share link for an analysis
 */
export const useShareAnalysis = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareAnalysis>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof shareAnalysis>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getShareAnalysisMutationOptions(options));
    }

export const getGetPublicAnalysisUrl = (token: string,) => {




  return `/api/analyses/public/${token}`
}

/**
 * @summary Get a publicly shared analysis by share token (no auth required)
 */
export const getPublicAnalysis = async (token: string, options?: Parameters<typeof customFetch>[1]): Promise<PublicAnalysis> => {

  return customFetch<PublicAnalysis>(getGetPublicAnalysisUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicAnalysisQueryKey = (token: string,) => {
    return [
    `/api/analyses/public/${token}`
    ] as const;
    }


export const getGetPublicAnalysisQueryOptions = <TData = Awaited<ReturnType<typeof getPublicAnalysis>>, TError = ErrorType<void>>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAnalysis>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicAnalysisQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicAnalysis>>> = ({ signal }) => getPublicAnalysis(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicAnalysis>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicAnalysisQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicAnalysis>>>
export type GetPublicAnalysisQueryError = ErrorType<void>


/**
 * @summary Get a publicly shared analysis by share token (no auth required)
 */

export function useGetPublicAnalysis<TData = Awaited<ReturnType<typeof getPublicAnalysis>>, TError = ErrorType<void>>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAnalysis>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicAnalysisQueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







